module.exports = __webpack_public_path__ + "static/media/report-cxc.b8667217.svg";